import React from 'react';
import { addYears } from 'date-fns';
import { FormatDateOptions, useIntl } from 'react-intl';
import DateInput, { DateChangeEvent } from 'carbon-react/lib/components/date';

import { getNextDay } from '../utils';
import { MAX_FUTURE_YEARS_FOR_ASSUMPTIONS } from '../../../../../core/constants';
import { forceLocalDate } from '../../../../../utils/dates';

import styles from '../repeating-method.scss';

interface EndDateProps {
  disabled?: boolean;
  onChange: (value: Date) => void;
  startDate: Date;
  value: Date | null;
}

const MAX_DATE = addYears(Date.now(), MAX_FUTURE_YEARS_FOR_ASSUMPTIONS);
const CUSTOM_DATE_FORMAT: FormatDateOptions = {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit'
};

export const EndDate = ({ disabled, onChange, startDate, value }: EndDateProps) => {
  const intl = useIntl();

  const handleDateChange = (e: DateChangeEvent) => onChange?.(forceLocalDate(e.target.value.rawValue || ''));

  return (
    <div className={styles.carbonDate}>
      <DateInput
        label={intl.formatMessage({ id: 'common.end_date', defaultMessage: 'End date' })}
        disabled={disabled}
        id="endDate"
        onChange={handleDateChange}
        value={
          value
            ? intl.formatDate(value, {
                day: '2-digit',
                month: 'short',
                year: 'numeric'
              })
            : ''
        }
        size="large"
        maxDate={intl.formatDate(MAX_DATE, CUSTOM_DATE_FORMAT)}
        minDate={intl.formatDate(getNextDay(startDate), CUSTOM_DATE_FORMAT)}
        disablePortal={false}
        maxWidth="185px"
      />
    </div>
  );
};
